import { findPorcessState } from '../../_services/process_state.service.js';
import { getCompany } from '../../_utils/storage_handler.js';

export const findAllProcessStateEvent = async () => {
    let res = await findPorcessState(getCompany());
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}